import React from 'react';

const ReportPageWrapper = ({ children, narrow = false }) => {
  return (
    <div className="flex-1 bg-gray-50 min-h-screen report-page-wrapper w-full max-w-full min-w-0 box-border p-4 sm:p-6 lg:p-8">
      <div
        className={
          `bg-white rounded-lg shadow-sm border border-gray-200 min-w-0 ` +
          (narrow ? 'max-w-2xl mx-auto p-6 sm:p-8' : 'p-4 sm:p-6')
        }
      >
        {children}
      </div>
    </div>
  );
};

export default ReportPageWrapper;
